import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { I18nPipe } from '@delon/theme';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { Subscription } from 'rxjs';
import { HttpService } from 'src/app/http/http.service';
import { TenantStateService } from 'src/app/services/tenant-state.service';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';
import { ConstantUtil } from 'src/app/util/constant.util';

@Component({
  selector: 'app-tenant-dashboard',
  standalone: true,
  imports: [CommonModule, NzCardModule, NzGridModule, NzStatisticModule, NzIconModule, NzSpinModule, I18nPipe, TestIdDirective],
  templateUrl: './tenant-dashboard.component.html',
  styleUrls: ['./tenant-dashboard.component.less']
})
export class TenantDashboardComponent implements OnInit, OnDestroy {
  private readonly http = inject(HttpService);
  private readonly tenantStateService = inject(TenantStateService);
  private tenantSubscription?: Subscription;
  private readonly cdr = inject(ChangeDetectorRef);

  loading = true;
  currentTenant: any = null;

  statistics = {
    aiffCount: 0,
    employeeCount: 0,
    serviceNumberCount: 0,
    bossServiceNumberCount: 0,
    contactCount: 0
  };

  ngOnInit(): void {
    this.tenantSubscription = this.tenantStateService.currentTenant$.subscribe(tenantId => {
      if (tenantId) {
        this.currentTenant = tenantId;
        this.fetchStatistics();
      }
    });
  }

  ngOnDestroy(): void {
    this.tenantSubscription?.unsubscribe();
  }

  private fetchStatistics(): void {
    this.loading = true;

    this.http.post(`${ConstantUtil.ADMIN_TENANT_DASHBOARD_INFO}/${this.currentTenant}`, {}).subscribe({
      next: res => {
        this.loading = false;
        if (res.success && res.data) {
          this.statistics = {
            aiffCount: res.data.aiffCount || 0,
            employeeCount: res.data.employeeCount || 0,
            serviceNumberCount: res.data.serviceNumberCount || 0,
            bossServiceNumberCount: res.data.bossServiceNumberCount || 0,
            contactCount: res.data.contactCount || 0
          };
          this.cdr.detectChanges();
        }
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
